import ContactPage from '../components/ContactPage';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Contact | Cartwheel',
  'Get in touch with Cartwheel about projects, partnerships, product support, and our community.',
);

export default ContactPage;
